import { E } from '@angular/cdk/keycodes';
import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({ selector: '[FocusOnNextFormElement]' })
export class FocusOnNextFormElement implements OnInit {
  constructor(private _el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.listenEnterPress(this._el.nativeElement);
  }

  listenEnterPress(element) {
    this.renderer.listen(element, 'keypress', handleKeypressEvent);
    this.renderer.listen(element, 'keydown', handleKeydownEvent);
    this.renderer.listen(element, 'paste', handleClipboardEvent);

  }


}
const handleKeypressEvent = (event: any) => {
  if (event.code == 'Space') {
    event.preventDefault()
  }

  if (event.code != 'Space' && event.target.defaultValue != '' && event.code != 'Enter') {
    event.target.defaultValue = event.key;
  }
  if (event.target.nextElementSibling && event.code != 'Space') {
    setTimeout(() => event.target.nextElementSibling.setFocus(), 100)

  }
}

const handleKeydownEvent = (event: any) => {
  if (event.target.nextElementSibling && event.code == 'Backspace' && event.target.defaultValue == '') {
    setTimeout(() => event.target.nextElementSibling.setFocus(), 10)

  }
}

const handleClipboardEvent = (event) => {
  const clipboardText = event.clipboardData.getData('Text');
  const textChars = [...clipboardText];
  populateNext(event.target, textChars);
}

function populateNext(element, values) {
  element.defaultValue = values[0];
  const v = values.slice(1)
  const sibling = element.nextElementSibling;
  if (sibling) {
    setTimeout(() => {
      sibling.setFocus()
      return populateNext(sibling, v);
    }, 10)

  }
  return;
}

